/* ============================================================================
   New Gallery — carousel
   ----------------------------------------------------------------------------
   PERF: Bu kod onceden sections/new-gallery.liquid icinde inline <script> olarak
   duruyordu. Ana sayfada 3 adet new-gallery section'i oldugu icin ayni 51 satir
   HTML dokumanina uc kez basiliyordu. Icinde hic Liquid yok, yani tamamen
   statik -- asset dosyasi olarak cache'lenmesi dogru olan.
   ============================================================================ */

if (!customElements.get('gallery-carousel')) {
  customElements.define(
    'gallery-carousel',
    class extends HTMLElement {
      connectedCallback() {
        setTimeout(() => {
          this.grid = this.querySelector('.ng-grid');
          this.prevBtn = this.querySelector('.gallery-arrow--prev');
          this.nextBtn = this.querySelector('.gallery-arrow--next');

          if (!this.grid || !this.prevBtn || !this.nextBtn) return;

          this.prevBtn.addEventListener('click', () => this.scroll(-1));
          this.nextBtn.addEventListener('click', () => this.scroll(1));
        }, 100);
      }

      scroll(direction) {
        const grid = this.querySelector('.ng-grid');
        if (!grid) return;

        // Tek bir kartin genisligini + aradaki gap degerini hesapla
        const firstItem = grid.firstElementChild;
        if (!firstItem) return;

        const gap = parseFloat(window.getComputedStyle(grid).gap) || 0;
        const scrollAmount = firstItem.offsetWidth + gap;

        const maxScroll = grid.scrollWidth - grid.clientWidth;
        const buffer = 15;

        if (direction === 1) {
          // Ileri (sag)
          if (grid.scrollLeft >= maxScroll - buffer) {
            grid.scrollTo({ left: 0, behavior: 'smooth' }); // sondayiz -> basa don
          } else {
            grid.scrollBy({ left: scrollAmount, behavior: 'smooth' });
          }
        } else {
          // Geri (sol)
          if (grid.scrollLeft <= buffer) {
            grid.scrollTo({ left: maxScroll, behavior: 'smooth' }); // bastayiz -> sona don
          } else {
            grid.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
          }
        }
      }
    }
  );
}